(function () {
	const getAccordionDuration = () => {
		if (!document.body.classList.contains('body-template-product')) return 300;
		const mainProductSection = document.querySelector('[id^="MainProduct-"]');
		return mainProductSection?.dataset.disableAboutAnimation === 'false' ? 300 : 0;
	};

	const initProductAccordion = () => {
		$('.about__accordion-title').off('click').click(function() {
			const accordionDuration = getAccordionDuration();
			const accordionContent = $(this).siblings('.about__accordion-description').first();
			const isActive = $(this).hasClass('active');

			$(this).toggleClass('active', !isActive);
			accordionContent.stop()[isActive ? 'slideUp' : 'slideDown'](accordionDuration);
		});
	};

	document.addEventListener('shopify:section:load', function () {
		initProductAccordion();
	});

	initProductAccordion();
})();
